module.exports = {
  designationCode: 'stockloads-australia',
  plugins: {
    hq: {
      site_title: 'Stock Loads',
      site_tagline: 'Livestock Transport System',
      privacy_policy: 'https://www.livestocktransportnation.com/privacy-policy?cleanMode=true',
      contact_info: {
        contact_us_href: 'https://www.stockloads.com.au/contact-us',
        site_corner_image: '/static/stockloads logo.png',
      },
    },
    locality: {
      lang: 'en',
      country: 'AU',
      locale: 'en-AU',
      load_map: {
        // allowed country for map initzer
        country_restrictions: ['au'],
        center: {
          lat: -25.583532,
          lng: 134.264383,
        },
      },
      units_of_measure: 'metric',
      is_aus: true,
    },
    loadboard: {
      enabled: false,
      states: [],
      enableBidding: false,
    },
  },
};



// WEBPACK FOOTER //
// ./src/api/siteDesignations/stockloads-australia.js